import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface InspectionState {
	organizationCategoryValue: string | null;
}

const initialState: InspectionState = {
	organizationCategoryValue: null,
};

const inspectionSlice = createSlice({
	name: "inspection",
	initialState,
	reducers: {
		setOrganizationCategoryValue: (state, action: PayloadAction<string | null>) => {
			state.organizationCategoryValue = action.payload;
		},
		clearInspectionState: (state) => {
			state.organizationCategoryValue = null;
		},
	},
});

export const { setOrganizationCategoryValue, clearInspectionState } = inspectionSlice.actions;
export default inspectionSlice.reducer;

